module.exports = __webpack_public_path__ + "media/warranty-claim/photos-close-up3-74fe6e68.png";